import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { OrganizationSchema, WebsiteSchema, HomePageSchema, FAQPageSchema, BreadcrumbSchema } from '@/components/feature/SchemaOrg';
import HeroSection from './components/HeroSection';
import LiveEventsSection from './components/LiveEventsSection';
import NewsSection from './components/NewsSection';
import BettingSection from './components/BettingSection';
import HealthSection from './components/HealthSection';
import CTASection from './components/CTASection';

export default function Home() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [pathname]);

  return (
    <>
      <OrganizationSchema />
      <WebsiteSchema />
      <HomePageSchema />
      <FAQPageSchema />
      <BreadcrumbSchema items={[{ name: '首页', url: '/' }]} />
      <Navbar />
      <main>
        <HeroSection />
        <LiveEventsSection />
        <NewsSection />
        <BettingSection />
        <HealthSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}